import React from 'react';
import { useMutation } from '@apollo/client';
import RemoveTestMutation from './RemoveTestMutation';
import { HashimotoTestInputType } from '../types';
import TestsQuery from '../Fetch/TestsQuery';

interface IRemoveTest {
  removeTest: {
    removeMeasurement: (request: any) => Promise<any>;
    response: unknown;
    loading: boolean;
  };
}
interface IRemoveTestConnectorApollo {
  children: (removeTest: IRemoveTest) => React.ReactElement;
}

const RemoveTestConnectorApollo: React.FC<IRemoveTestConnectorApollo> = ({ children }) => {
  const [removeTest, { data, loading }] = useMutation(RemoveTestMutation);

  const createRemoveMeasurement = async (request: HashimotoTestInputType) => {
    const response = await removeTest({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TestsQuery,
        },
      ],
    });

    return response;
  };

  return children({
    removeTest: {
      removeMeasurement: createRemoveMeasurement,
      response: data,
      loading,
    },
  });
};

export default RemoveTestConnectorApollo;
